import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " Du hast noch keine Türchen geöffnet, vielleicht gibt es ein Anzeigeproblem in Deinem Webbrowser? ", -1)
const _hoisted_2 = { class: "level" }
const _hoisted_3 = { class: "level-item" }
const _hoisted_4 = { class: "level-item" }
const _hoisted_5 = { class: "image is-unselectable" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiModal = _resolveComponent("MultiModal")!
  const _component_BulmaButton = _resolveComponent("BulmaButton")!
  const _component_BulmaToast = _resolveComponent("BulmaToast")!
  const _component_CalendarDoor = _resolveComponent("CalendarDoor")!
  const _component_ThouCanvas = _resolveComponent("ThouCanvas")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MultiModal, { onHandle: _ctx.modal_handle }, null, 8, ["onHandle"]),
    _createVNode(_component_BulmaToast, {
      onHandle: _ctx.toast_handle,
      class: "content"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BulmaButton, {
              class: "is-success",
              text: "Türchen anzeigen",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {
            _ctx.store.is_touch_device = true;
            _ctx.toast?.hide();
          }, ["left"]))
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_BulmaButton, {
              class: "is-danger",
              text: "Ich möchte selbst suchen",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toast?.hide()), ["left"]))
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["onHandle"]),
    _createElementVNode("figure", null, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: _ctx.store.calendar_background_image
        }, null, 8, _hoisted_6),
        _createVNode(_component_ThouCanvas, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doors, (door, index) => {
              return (_openBlock(), _createBlock(_component_CalendarDoor, {
                key: `door-${index}`,
                door: door,
                visible: _ctx.store.is_touch_device,
                title: _ctx.$advent22.name_door(door.day),
                onClick: ($event: any) => (_ctx.door_click(door.day)),
                style: {"cursor":"pointer"}
              }, null, 8, ["door", "visible", "title", "onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}